import React from "react";
import "./Turntable_Event_Description_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

function Turntable_Event_Description_card() {
  return (
    <section className="Turntable_Event_Description_card">
      <div className="container">
        {/* Activity Time */}
        <div className="card_box">
          <div className="card_header">
            <span className="arrow">
              <FontAwesomeIcon icon={faPlay} />
            </span>
            <span>Activity time</span>
          </div>
          <div className="text_holder">
            <p className="card_text">From now on</p>
          </div>
        </div>

        {/* Validity Period */}
        <div className="card_box">
          <div className="card_header">
            <span className="arrow">
              <FontAwesomeIcon icon={faPlay} />
            </span>
            <span>Validity period</span>
          </div>
          <div className="text_holder">
            <p className="card_text">
              Official website notification shall prevail
            </p>
          </div>
        </div>

        {/* Highlight Message */}
        <div className="card_box">
          <div className="text_holder">
            <p>
              <span className="red">
                Members whose single deposit amount or accumulated deposit
                amount reaches the set amount can participate in the lottery..
              </span>
            </p>
          </div>
        </div>

        {/* Conditions */}
        <div className="card_box">
          <div className="card_header">
            <span className="arrow">
              <FontAwesomeIcon icon={faPlay} />
            </span>
            <span>Conditions of participation</span>
          </div>

          <div className="text_holder">
            <p>
              Members who meet the requirements of{" "}
              <span className="red">
                Vip1, Vip2, Vip3, Vip4, Vip5, Vip6, Vip7, Vip8, Vip9, Vip10
              </span>{" "}
              can participate in the bigwheel event. Need to bind a bank card.
              Hundreds of millions of cash and many other prizes are up for
              grabs. Get ready for endless surprises and grand prizes every day!
            </p>

            <p className="mt">
              Need to bind <span className="red">Bank account</span>
            </p>

            <p>
              With hundreds of millions in cash and many other prizes up for
              grabs, get ready for endless surprises and big prizes every day!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Turntable_Event_Description_card;
